import React, { useState } from 'react';
import "../client/Canuckz/CanuckzNav.css";

function Navbar(props) {
  const [isActive, setIsActive] = useState(false);

  return (

      

          <nav id="topbar" className={`navbar ${isActive ? 'has-opaque-background' : ''}`} role="navigation" aria-label="main navigation">
            <div className="container is-max-widescreen">
            <div className="navbar-brand">
              <a className="navbar-item" href="https://canuckz-nft.io/">
                <img id="topbar-logo" src="CanuckzNFT-logo-2.png" height="32" alt="Topbar logo." />
              </a>
              <button
                href=""
                className={`navbar-burger navbar ${isActive && 'is-active'}`}
                onClick={() => setIsActive(a => !a)}
                aria-label="menu"
                aria-expanded="false">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </button>
            </div>

            <div className={`navbar-menu is-relative has-text-centered ${isActive ? 'is-active' : ''}`}>
              <div className="navbar-end">
                <a href="https://canuckz-nft.io/" className="navbar-item">
                  Home
                </a>

                <a className="navbar-item" href="https://canuckz-nft.io/about">
                  About
                </a>

                <a href="https://canuckz-nft.io/faq" className="navbar-item">
                  FAQ
                </a>

                <a href="/" className="navbar-item">
                  Charli3 CNFT
                </a>
                <div id="buy-button-container" className="navbar-item is-flex is-justify-content-center">
                  <a href="/" id="buy-button" className="button is-primary navbar-item">Buy</a>
                </div>
              </div>
            </div>
            </div>
          </nav>
  );
}

export default Navbar;